<template>
  <div>
    <span v-for="prop in header.computed" :key="prop">{{ getNestedValue(item[header.value], prop) }} </span>
  </div>
</template>

<script>
export default {
  name: 'NestedComputedTextContent',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    header: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    getNestedValue (obj, path) {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    }
  }
};
</script>
